import { useMemo } from 'react'
// import { AnimatePresence, LazyMotion, domAnimation, m } from 'framer-motion'
import { heatMapColors } from '../../../utils/heatMapUtils'
import { usePolygonStore } from '../../../../../state-library/src'

const HeatMapTooltip = (): JSX.Element => {
  const { heatMapCategory, isHoveredHeatMapCategorySelector: isOpened } =
    usePolygonStore()

  const colors = useMemo(() => {
    if (!heatMapCategory) {
      return []
    }
    return [
      heatMapColors[heatMapCategory as keyof typeof heatMapColors].very_low,
      heatMapColors[heatMapCategory as keyof typeof heatMapColors].medium_low,
      heatMapColors[heatMapCategory as keyof typeof heatMapColors].very_high,
    ]
  }, [heatMapCategory])

  return (
    <div>
      {/* <AnimatePresence> */}
      {isOpened ? (
        // <LazyMotion features={domAnimation}>
        <div className="absolute mt-3">
          <div
            // initial={{ translateY: '-10px', opacity: 0 }}
            // animate={{
            //   translateY: 0,
            //   opacity: 1,
            // }}
            // transition={{ duration: 0.18 }}
            // exit={{ translateY: '-10px', opacity: 0 }}
            className="grid grid-cols-[min-content,min-content] gap-2.5 bg-white p-2 rounded-lg"
          >
            <div className="flex flex-col w-max h-max rounded-full overflow-hidden">
              {colors.map((color) => (
                <div
                  key={color}
                  className="h-4 w-1 bg-"
                  style={{
                    backgroundColor: color,
                  }}
                />
              ))}
            </div>
            <div className="h-full flex flex-col justify-between">
              <p className="text-body-xs">Bajo</p>
              <p className="text-body-xs">Alto</p>
            </div>
          </div>
        </div>
      ) : // </LazyMotion>
      null}
      {/* </AnimatePresence> */}
    </div>
  )
}

export default HeatMapTooltip
